<p-tabView #primeTabMenu
           [orientation]="orientation"
           [class]="'p-tabview-' + orientation"
           (onChange)="onTabChange($event)">

    <ng-content></ng-content>

</p-tabView>